<template>
    <div class="flex overflow-hidden">
        <div class="flex w-10 shrink-0 items-start justify-center">
            <icon icon="cil-check-circle" class="h-[22px]" />
        </div>
        <div class="overflow-hidden">
            <div>
                <b class="block truncate">{{ trans('notification.user.access_restored.title') }}</b>
            </div>
            <small class="line-clamp-2 block text-wrap text-gray-500">{{ description }}</small>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    notification: {
        type: Object,
        required: true,
    },
});

const isAdmin = computed(() => {
    return props.notification.payload.isAdmin === true;
});

const description = computed(() => {
    if (isAdmin.value) {
        return trans('notification.user.access_restored.admin.description', {
            name: props.notification.payload.name,
        });
    } else {
        return trans('notification.user.access_restored.description');
    }
});
</script>
